import {
  ThemeUICSSObject,
  getColorsAndStatesByPath,
  spacing,
} from '@apia/theme';
import files from './files';
/* IMPORT HERE */

const translation: ThemeUICSSObject = {
  files,
  '&.modalTranslate': {
    flexDirection: 'column',
    flex: 1,
    gap: spacing(4),
    display: 'flex',
    height: '50vh',
    overflow: 'auto',
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  '.modalTranslate__languageSelector': {
    maxHeight: '50vh',
    flexDirection: 'column',
    display: 'contents',
    justifyContent: 'center',
    flexShrink: 0,
    justifySelf: 'start',
    alignSelf: 'center',
  },

  '.react-select__control': {
    borderRadius: '0px',
  },

  '.languageList': {
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,

    '[role="checkbox"]': {
      border: 'none',
      height: '22px',
      width: '20px',
      background: 'transparent',
    },
    '.languageList__languageSelection': {
      borderStyle: 'solid',
      borderWidth: '1px',
      alignItems: 'center',
      cursor: 'default',
      width: 'fit-content',
    },

    '.languageList__languageSelection div': {
      borderWidth: '0px',
      borderStyle: 'none',
    },
    '.languageList__languageSelection__open': {
      height: '20vh',
      maxHeight: '100%',
      width: '400px',
    },
  },
  '.modalTranslate__languageTranslate': {
    flex: 'initial',
    display: 'flex',
    justifySelf: 'stretch',
    alignSelf: 'center',
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'center',
    width: '100%',
  },
  '.modalTranslate__languageTranslate__container': {
    width: 'auto',
    maxWidth: '1000px',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
  '.languageTranslate__editor': {
    height: '50vh',

    '.editor': {
      height: '300px',
    },
  },

  '.modalTranslate__languageTranslate__fieldValue': {
    fontWeight: 'normal',
  },

  '.translateField__textArea': {
    width: '50vw',
    maxWidth: '100%',
    // maxHeight: responsive({ 0: '90vh', 3: '45vw' }),
    height: '60%',
    borderRadius: '0px',
  },

  '&.translateField__textArea:focus': {
    // border: '1px solid red',
  },
  '.languageList ': {
    position: 'sticky',
    top: '0px',
    zIndex: 100,
    backgroundColor: 'palette.background.paper',
    // pl: spacing(3),
  },
  '.languageList div.open': {
    backgroundColor: 'palette.background.paper',
  },

  '.languageList div.selected': {
    backgroundColor: 'buttons.openTab.backgroundColor',
  },
  '.languageNotSelected': { height: '15vh' },
  '.translateModal__fieldName': { display: 'flex', gap: 3 },

  translateModalButton: {
    '&.iconButton': {
      mr: spacing(3),
      cursor: 'pointer',
      height: '24px',
      minHeight: '24px',
      p: spacing(0),
      width: 'smallIcon',
      minWidth: 'smallIcon',

      ...getColorsAndStatesByPath('buttons.transparentIcon'),
    },
  },

  '.translateModal__fields__content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  '.lessHeight': {
    height: '180px',
  },
  '.translateModal__fields__hasEditor label': {
    width: '50%',
  },
  '.editor__field': {
    height: '90%',
    minHeight: '300px',
  },
  '.fieldLabel__container': {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid ',
    borderColor: 'palette.gray.800',
    overflow: 'auto',
    minHeight: '50px',
    p: spacing(2),
    overflowX: 'hidden',
    width: '100%',
  },
  '.fieldLabel__container__hasEditor': {
    display: 'flex',
    alignItems: 'baseline',
    border: '1px solid ',
    borderColor: 'palette.gray.800',
    overflow: 'auto',
    height: '60%',
    p: spacing(2),
    overflowX: 'hidden',
    width: '100%',
  },
  '.fieldLabel': {
    position: 'sticky',
    top: '0',
    background: 'palette.background.paper',
  },
  '.translateModal__fields__hasEditor': {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '500px',
    p: 0,
  },
  '.translateModal__label': {
    display: 'flex',
    flexDirection: 'column',
  },
  '.translateModal__label__hasEditor': {
    width: '49%',
  },
  '.modalTranslate__languageTranslate__fieldValue  p': {
    margin: 0,
  },
  '.languageTranslate__translateField__fieldCointainer__hasEditor': {
    width: '51%',
  },

  '.hasMore': {
    height: '90%',
  },
  /* PREPEND HERE */
};

export default translation;
